import React from 'react';

import styled from '@emotion/styled';

interface FormButtonAreaProps {
  children: React.ReactNode;
  marginTop?: string;
}
const FormButtonArea: React.FC<FormButtonAreaProps> = ({
  children,
  marginTop,
}) => {
  return <Container marginTop={marginTop}>{children}</Container>;
};

export default FormButtonArea;

interface ContainerProp {
  marginTop?: string;
}

const Container = styled.div<ContainerProp>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '20px')};
`;
